import * as React from 'react';
import { Button, Icon } from 'sg-styleguide';

const SelectButton = ({ selected, text, textSelected, icon = 'check', intl, postfix = null, ...props }) => {
	if (selected) {
		return (
			<Button {...props} color="primary" style={{ maxWidth: '200px' }}>
				<Icon name={icon} />
				{textSelected || intl.formatMessage({ id: 'generic.selected' })}
				{postfix}
			</Button>
		);
	}

	return (
		<Button {...props} type="outlined" color="primary" style={{ maxWidth: '200px' }}>
			{text || intl.formatMessage({ id: 'generic.select' })}
			{postfix}
		</Button>
	);
};

export default SelectButton;
